import React, { useRef } from "react";
import snapshotsData from "./snapshotsdata";
import "./snapshots.css";

const Snapshots = () => {
  const topRef = useRef(null);

  const scrollToTop = () => {
    topRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  const centered = {
    display: 'flex',
    flexDirection: 'column',    // stack <h1> over <p>
    alignItems: 'center',       // horizontal centering
    justifyContent: 'center',   // vertical centering *if* you give it a height
    minHeight: '20vh'           // or '100vh' if you want it dead-center the page
  };

  return (
    <div style={{ padding: "2rem" }}>
      
      <div ref={topRef} style={centered}>
        <h1>Snapshots</h1>
        <p>Here are some memories from our events!</p>
      </div>

      <div className="gallery">
        {snapshotsData.map((snapshot, index) => (
          <div className="gallery-item" key={index}>
            <img src={snapshot.imgsrc} alt={`Snapshot ${index}`} />
          </div>
        ))}
      </div>

      <button onClick={scrollToTop} className="scroll-button">
        Scroll to Top
      </button>
    </div>
  );
};

export default Snapshots;
